import { toSnakeCase } from './components/shared/to-snake-case'

const config = {
    SYSTEM_NAME: 'Test app',
    DEFAULT_DESCRIPTION: 'This application is written as demo app',
    DESCRIPTION: 'Test app',
    TITLE: 'Test app',
    GOOGLE_MAPS_API_KEY: 'AIzaSyAvbUNzF_j78dUWdJoc4e13gY0-fSL_Hy8',
    TINYMCE_API_KEY: 'gpdqdfshzw5shlum74wknai8lys1ohn0w71gxqlew8m8ilbi',
}

const dataset = document.getElementById('platform-body').dataset
const dataConfig = Object.keys(dataset).reduce((element, key) => (element[toSnakeCase(key).toUpperCase()] = dataset[key], element), {})

window.APP_CONFIG = Object.assign({}, config, dataConfig)

require('./index')
